import styles from "./about.module.scss";
// import eu from "../../../assets/eu.png";

export const About = () => {
  return (
    <section id="sobre" className={styles["container"]}>
      <div className={styles["inner"]}>
        <header className={styles["head"]}>
          <span className={styles["label"]}>01 — Sobre</span>
          <h2 className={styles["title"]}>
            Transformo ideias em interfaces que as pessoas realmente usam
          </h2>
        </header>

        <div className={styles["grid"]}>
          <div className={styles["text"]}>
            <p className={styles["lead"]}>
              Sejam bem-vindos! Me chamo Matheus e sou desenvolvedor frontend.
            </p>
            <p>
              Cursando Engenharia de Computação no IFCE, atuo como desenvolvedor
              há quase 4 anos. Iniciei minha trajetória no desenvolvimento
              backend, mas ao longo do tempo migrei para o frontend para apoiar
              a equipe nas entregas, área na qual sigo até hoje. Nesse período,
              participei de diversos projetos utilizando tecnologias como React
              e Angular, além de ter tido uma breve experiência com
              desenvolvimento mobile.
            </p>
            <p>
              Gosto de trabalhar próximo do design, discutir arquitetura de
              componentes e cuidar dos detalhes que separam uma tela funcional
              de uma boa experiência.
            </p>

            <ul className={styles["info"]}>
              <li>
                <span>Localização</span>
                <strong>Fortaleza, CE — Brasil</strong>
              </li>
              <li>
                <span>Formação (em andamento)</span>
                <strong>Engenharia de Computação — IFCE</strong>
              </li>
              <li>
                <span>Foco atual</span>
                <strong>React, TypeScript e Angular</strong>
              </li>
            </ul>
          </div>

          {/* <div className={styles["media"]}>
            <div className={styles["photo"]}>
              <img alt="descrição" src={eu}/>
            </div>
            <div className={styles["frame"]} />
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default About;
